import { Pipe, PipeTransform } from '@angular/core';
import { DomainType, Invoice, InvoiceStatus } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;

@Pipe({
    name: 'invoiceStatus',
    standalone: true
})

export class InvoiceStatusPipe implements PipeTransform {

    transform(invoice: Invoice): string {
        const { status, outstandingAmount } = invoice;

        const domainType = ConfigService.environment.domainType;

        if (domainType === DomainType.ClientPortal) {

            if (status !== InvoiceStatus.Approved) return status;

            return outstandingAmount > 0 ? 'Awaiting Payment' : 'Paid';
        }

        return status;
    }

}